export default __webpack_public_path__ + "static/media/tec4green.89665319.png";